<template>
    <div>
        <viewer :options="options_default" :images="images" @inited="inited" :class="['viewer', classViewer]" ref="viewer">
            <template slot-scope="scope">
                <slot name="gofixViewer:list_image" v-bind:images="scope.images"></slot>
                <!-- <template v-if="showImage">
                    <img class="d-none" v-for="item in scope.images" :src="item.url.original" :key="item.url.original">
                </template> -->
            </template>
        </viewer>
    </div>
</template>
<script>
import Viewer from "v-viewer/src/component.vue"
export default {
    name: 'viewer-image',
    components: {
        Viewer
    },
    props: {
        images : {
            type: Array,
            default: () => []
        },
        options : {
            type: Object,
            default: () => {}
        },
        showImage: {
            type: Boolean,
            default: false
        },
        classViewer: {
            type: String,
            default: ''
        },
    },
    data: function () {
        return {
            options_default: {
                toolbar: {
                    download: {
                        show: 4, 
                        size: 'medium', 
                        click: this.downloadImage
                    },
                    zoomIn: 4,
                    zoomOut: 4,
                    oneToOne: 4,
                    reset: 4,
                    prev: 4,
                    play: {
                      show: 4,
                      size: 'large',
                    },
                    next: 4,
                    rotateLeft: 4,
                    rotateRight: 4,
                    flipHorizontal: 4,
                    flipVertical: 4,
                }
            }
        }
    },
    created(){
        this.options_default = Object.assign(this.options_default, this.options)
    },
    methods: {
        inited (viewer) {
            this.$viewer = viewer
        },
        modalImage() {
            this.$viewer.show()
        },
        async downloadImage() {
            let elementImg = document.querySelector('.viewer-container.viewer-in img.viewer-move')
            let src = '';
            if(elementImg) {
                src = elementImg.getAttribute('src');
                let alt = elementImg.getAttribute('alt');
                var a = document.createElement('a');
                a.href = src;
                a.download = alt;
                document.body.appendChild(a);
                a.click();    
                a.remove();
            }
        }
    }
}
</script>

